export const standardDateFormat = 'YYYY-MM-DD, HH:mm';

// This is the format that is accepted by the input type datetime-local
// Pre-filling with another format fill just silently fail so that's a gotcha
// Used to set minDate/maxDate on the input
export const dateFormatInputCanAccept = 'YYYY-MM-DDTHH:mm';
